<template>
    <div>
        <b-row align-v="center">
            <b-col cols="1" sm="2"	md="2"	lg="2"	xl="5">
                <b-form inline>
                    Desde: <datepicker class="ml-1 mr-4" v-model="f1" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                    Hasta: <datepicker class="ml-1 mr-1" v-model="f2" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                </b-form>
            </b-col>
            <b-col cols="1" sm="2"	md="2"	lg="2"	xl="1">
                <b-button @click="reportePagos()" variant="success">Buscar</b-button>
            </b-col>
            <b-col cols="1" sm="2"	md="2"	lg="2"	xl="1">
                <b-button variant="secondary" @click="reportePagos"><i class="fa fa-sync-alt"></i> </b-button>
            </b-col>
            <b-col cols="1" sm="2"	md="2"	lg="2"	xl="2">
                <b-form-group horizontal label="Orden" class="mb-0">
                    <b-input-group>
                    <b-form-select v-model="orden" slot="append" @input="reportePagos">
                        <option :value="'asc'">Más Antiguo</option>
                        <option :value="'desc'">Más Reciente</option>
                    </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="1" sm="2"	md="2"	lg="2"	xl="2"> 
                <b-form-group horizontal label="Mostrar" class="mb-0">
                    <b-input-group>
                        <b-form-select v-model="limite" slot="append" @input="reportePagos">
                        <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" sm="6"	md="2"	lg="2"	xl="1">
                <div class="text-right">
                    <b-button v-if="!loadingexcelreport" variant="warning" @click="downloadReportExcel()"><i class="fa fa-file-excel"></i> Exportar</b-button>
                    <b-button v-else variant="secondary"><i class="fa fa-spin fa-spinner"></i> Procesando</b-button>
                </div>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" class="text-center">
                <b-alert variant="warning" class="titleproductosvendidos p-0 pt-1 pb-1 pl-4" show> Desde {{ f1==''? $moment().format('D/M/Y'):f1 | moment('D/M/Y') }} hasta {{ f2==''? $moment().format('D/M/Y'):f2 | moment('D/M/Y') }}</b-alert>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                <b-table 
                    striped 
                    responsive
                    hover
                    small 
                    :current-page="pactual"
                    :per-page="limite"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :busy="procesando"
                    :items="reportepagos" 
                    :fields="reportepagos_fields"
                    >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="serie" slot-scope="row">
                        {{ row.item.creditdocument.serie }}
                    </template>
                    <template slot="numero" slot-scope="row">
                        {{ row.item.creditdocument.numero }}
                    </template>
                    <template slot="fechaEmision" slot-scope="row">
                        {{ row.item.creditdocument.fechaEmision | moment('Y-M-D') }}
                    </template>
                    <template slot="receptor" slot-scope="row">
                        {{ row.item.creditdocument.idReceptor }}-{{ row.item.razonSocial }}
                    </template>
                    <template slot="cuenta" slot-scope="row">
                        <template v-if="row.item.infoBanco">
                            {{ row.item.infoBanco.numeroCuenta }}
                        </template>
                    </template>
                    <template slot="operacion" slot-scope="row">
                        <template v-if="row.item.infoBanco">
                            {{ row.item.infoBanco.numeroOperacion }}
                        </template>
                    </template>
                   <template slot="importe" slot-scope="row">
                       <div>
                            <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
                            <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
                            <template v-else>{{ row.item.tipoMoneda }}</template>
                            {{ row.item.importePagado }}
                        </div>
                    </template>
                    <template slot="fechaPago" slot-scope="row">
                        {{ row.item.fechaPago | moment('Y-M-D') }}
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <button size="sm" @click="row.toggleDetails" type="button" class="btn" title="Detalles">
                            <template v-if="!row.item.mostrardetalles">
                                <i class="fa fa-plus"></i>
                            </template>
                            <template v-else>
                                <i class="fa fa-minus"></i>
                            </template>
                        </button>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card>
                            <template v-if="row.item.infoBanco">
                                <b-row>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Deposito realizado en: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        {{row.item.infoBanco.banco}}
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Forma pago: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        {{convertFormaPago(row.item.formaPago)}}
                                    </b-col>    
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Numero de cuenta: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        {{row.item.infoBanco.numeroCuenta}}
                                    </b-col> 
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Fecha de vencimiento: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        {{ row.item.creditdocument.vencimiento | moment('Y-M-D') }}
                                    </b-col>    
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Código Interbancario: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        {{row.item.infoBanco.cci}}
                                    </b-col> 
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Registro de pago: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        {{ row.item.created_at | moment('Y-M-D') }}
                                    </b-col>    
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Tipo cuenta: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        {{row.item.infoBanco.tipoCuenta}}
                                    </b-col>    
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                        <b>Observaciones: </b>
                                    </b-col>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="10">
                                        {{row.item.observaciones}}
                                    </b-col>    
                                </b-row>
                            </template>
                        </b-card>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <div class="row">
            <div class="col-md-6">
                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
            </div>
            <div class="col-md-6">
                <div class="float-right">
                    <b-pagination size="sm" :total-rows="total" v-model="currentPage" @input="reportePagos" :per-page="limite"></b-pagination>
                </div>            
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import downloadexcel from "vue-json-excel"
import Datepicker from 'vuejs-datepicker'
import download from 'downloadjs'
import { FormaPago } from '@/shared/utils'
    export default {
        name: 'ReportePagos',
        components: {
            downloadexcel,
            Datepicker
        },
        data: () => {
            return {
                titleexcelrango: 'Reporte de emisiones ',
                loadingexcelreport: false,
                formaPago: FormaPago,
                f1: '',
                f2: '',
                // json_data: [],
                procesando: false,
                reportepagos: [],
                reportepagos_fields: [
                    {key: 'serie', label: 'Serie', sortable: true},
                    {key: 'numero', label: 'Numero', sortable: false},
                    {key: 'fechaEmision', label: 'Emision', sortable: false},
                    {key: 'receptor', label: 'Receptor', sortable: false},
                    {key: 'cuenta', label: 'Nro Cuenta', sortable: false},
                    {key: 'numeroOperacion', label: 'Nro Operación', sortable: false},
                    {key: 'importe', label: 'Importe', sortable: false},
                    {key: 'fechaPago', label: 'Fecha Pago', sortable: false},
                    {key: 'acciones', label: 'Acciones'}
                ],
                responseExportExcel: true,
                currentdate: '',
                pactual: 1,
                limite: 10,
                orden: 'desc',
                sortBy: null,
                sortDesc: false,
                sortDirection: 'asc',
                currentPage: 1,
                totalRows: null,
                filter: null,
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
            }
        },
        mounted() {
            this.reportePagos(),
            this.initDates()
        },
        methods: {
            downloadReportExcel: function () {
                let fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss')
                let fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss')
                if(this.f1 != '' || this.f2 != ''){
                    this.f1 == '' ? fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                    this.f2 == '' ? fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha2 = this.$moment(this.f2).format('YYYY-MM-DD HH:mm:ss')
                }
                let file = ''
                let tag = document.createElement('i')
                tag.classList.add('fa','fa-spin', 'fa-spinner')
                let name = this.titleexcelrango +' '+ fecha1 + '-' + fecha2 + '.xlsx'            
                this.loadingexcelreport = true
                this.$swal({
                    title: 'Procesando Reporte',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                })
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/reporte/pagos/excel', {
                    token: this.$store.getters.userToken,               
                    f1: fecha1,
                    f2: fecha2
                })
                .then(response => (
                file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64,
                this.loadingexcelreport = false,               
                download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
                this.$swal.close()
                ))
                .catch(error => {})
            },
            convertFormaPago: function (data) {
                var val = '';
                this.formaPago.forEach(function(element) {
                    if(element.codigo == data){
                        val = element.nombre
                    }
                });
                return val
            },
            customFormatter: function (date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            },
            initDates: function () {    
                this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss');
            },
            reportePagos() {
                let fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss')
                let fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss')
                if(this.f1 != '' || this.f2 != ''){
                    this.f1 == '' ? fecha1 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                    this.f2 == '' ? fecha2 = this.$moment().format('YYYY-MM-DD HH:mm:ss'): fecha2 = this.$moment(this.f2).format('YYYY-MM-DD HH:mm:ss')
                }
                this.procesando = true
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/reporte/pagos',{
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden,
                    f1: fecha1,
                    f2: fecha2
                })
                .then(response => (
                    this.procesando = false,
                    this.reportepagos = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to                        
                ))
                .catch(error => (
                    this.procesando = false
                ))
            },
            makeExcel: function (reporte) {
                let lista = []
                // this.reportepagos.forEach(function(value, key) {
                //     let data = {};
                //     data.Item = key;
                //     data.Serie = value.creditdocument.serie;
                //     data.Numero = value.creditdocument.numero;
                //     data.Emision = value.creditdocument.fechaEmision;
                //     data.Vencimiento = value.creditdocument.vencimiento;
                //     data.Documento = value.creditdocument.idReceptor;
                //     data.RazonSocial = value.razonSocial;
                //     data.FechaPago = value.fechaPago;
                //     if(Object.keys(value.infoBanco).length != 0 && value.infoBanco===null){
                //         data.Banco = value.infoBanco.banco;
                //         data.Cuenta = value.infoBanco.numeroCuenta;
                //         data.CCI = value.infoBanco.cci;
                //     };
                //     lista.push(data);
                // })
                this.json_data = this.reportepagos
                if(this.json_data.length > 0){
                    this.responseExportExcel = false
                }
            }
        }
    }
</script>

<style>
    .uno{
        background-color:red;
    }
</style>